import { HttpParams } from '@angular/common/http';

import { UrlParameterModel } from '../../../models/core/url-parameter.model';

/**
 * URL tools.
 */
export class Url {
    /**
     * Generates an URL.
     * @param url URL's Controller/Action.
     * @param baseUrl URL's base.
     * @param [isBase] Whether or not should "/api/" be used, if the URL is already a base.
     * @param [id] Record's ID.
     */
    static getUrl(url: string, baseUrl: string, isBase = false, id?: string): string {
        const currentUrl = Url.trimTrailingSlash(baseUrl) + (isBase ? '' : '/api') + `/${Url.trimLeadingAndTrailingSlash(url)}`;
        return id ? `${currentUrl}/${id}` : currentUrl;
    }

    /**
     * Generates a HttpParams based on provided values.
     * @param params URL parameters.
     */
    static getParams(params: UrlParameterModel[]): HttpParams {
        let httpParams = new HttpParams();

        for (const param of params) {
            if (httpParams.has(param.key)) {
                httpParams = httpParams.append(param.key, param.value);
            } else {
                httpParams = httpParams.set(param.key, param.value);
            }
        }

        return httpParams;
    }

    /**
     * Transforms an object into an array of UrlParameterModel.
     * @param obj Object to be transformed
     * @param prefix Prefix of the key
     */
    static transformToUrlParameterModel(obj: any, onlyWithValue = false, prefix?: string): UrlParameterModel[] {
        const params: UrlParameterModel[] = [];

        Object.keys(obj).forEach(k => {
            if (!onlyWithValue || obj[k]) {
                params.push(new UrlParameterModel({ key: `${prefix ? prefix : ''}${k}`, value: obj[k] }));
            }
        });

        return params;
    }

    /**
     * Removes the last (trailing) slash (/) from URL, if any.
     * @param url URL.
     */
    static trimTrailingSlash(url: string): string {
        return url.replace(new RegExp('/$'), '');
    }

    /**
     * Removes the first (leading) and last (trailing) slash (/) from URL, if any.
     * @param url URL.
     */
    static trimLeadingAndTrailingSlash(url: string): string {
        return url.replace(new RegExp('^/|/$', 'g'), '');
    }
}
